<template lang="pug">
  v-container.align-self-start.pa-0.ma-0
    v-snackbar( v-model="snackBar" :color="snackBarColor" ) {{ snackBarMessage }}
      template( v-slot:action="{attrs}")
        v-btn(text v-bind="attrs" @click="snackBar = false")
          v-icon fas fa-times
    RatingDialog(v-if="showDetailLastOrderClick" :ratingDataList="ratingDataList" :show="showDetailLastOrderClick" :ratingDeliveryTimeData="ratingDeliveryTimeData"
                @close="closeRatingDialog" :lastReservationDetailData="getReservationData" :selectedRatingValue="ratingValue" :date="date"
                :selectedOfferRating="selectedOfferRating" :itemData="itemData"
                @refreshData="refreshData")
    v-card.pa-0(flat :width="getCardClass")
      v-card-title {{ $t('myOrderPage.myOrderPageTitle') }}
      v-card-text.pa-0
        v-row.ma-0.align-center
          v-col.text-md-start.pl-md-0(cols="3" md="1" xl="1")
            v-btn(fab icon)
              v-icon(color="teal" @click="onPrevButtonClick") fas fa-chevron-circle-left
          v-col.text-center(cols="6" md="4" xl="4")
            v-menu(
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            )
              template(v-slot:activator="{ on, attrs }")
                v-btn(v-bind="attrs" v-on="on" text) {{getMonth}}
              v-date-picker(
                v-model="selectedMonth"
                type="month"
                no-title
                prev-icon="fas fa-chevron-left"
                next-icon="fas fa-chevron-right"
                @change="onMonthChange"
              )
          v-col.text-end.text-md-start(cols="3" md="7" xl="7")
            v-btn(fab icon )
              v-icon(color="teal" @click="onNextButtonClick")  fas fa-chevron-circle-right
        v-tabs(v-if="$vuetify.breakpoint.smAndDown" v-model="tab" grow)
          v-tab.pa-0 {{ $t('myOrderPage.detailSummary') }}
          v-tab.pa-0 {{ $t('myOrderPage.summary') }}
        v-tabs(v-else v-model="tab" )
          v-tab {{ $t('myOrderPage.detailSummary') }}
          v-tab {{ $t('myOrderPage.summary') }}
        v-row.ma-0.pt-3.justify-center
          v-col.text-end.pr-2(cols="4")
            v-icon( color="primary" ) fas fa-circle
            span.pl-1 {{ $t('myOrderPage.active') }}
          v-col.text-center.pr-0.pl-0(cols="4")
            v-icon( color="success" ) fas fa-circle
            span.pl-1 {{ $t('myOrderPage.delivered') }}
          v-col.text-start.pl-2(cols="4")
            v-icon( color="error" ) fas fa-circle
            span.pl-1 {{ $t('myOrderPage.canceled') }}
        v-tabs-items(v-model="tab" v-if="!fetchInProgress")
          v-tab-item.pt-3
            v-card.elevation-0
              v-card-text(v-if="!fetchInProgress && itemData.length === 0")
                v-row.ma-0.justify-space-around()
                  v-col.text-center.font-weight-bold.title(justify="center" cols="12") Žiadne objednávky
              v-card-text.overflow-y-auto(style="height: 55vh" v-else)
                v-list
                  template(v-for="(dateItem, dateIdx) in itemData")
                    v-row.ma-0
                      v-col.text-start.pa-0(md="4" cols="12")
                        v-subheader.subtitle-2 {{ getDate(dateItem.date) }}

                    v-divider

                    template(v-for="(topMenuGroup, topIdx) in dateItem.dataPerTopMenuGroup")
                      template(v-for="(subMenuGroup, subIdx) in topMenuGroup.subMenuGroupData")
                        v-list-item.pa-0(
                          v-for="(slotItem, slotIdx) in subMenuGroup.slots"
                          :key="`${dateIdx}-${topIdx}-${subIdx}-${slotIdx}`"
                          two-line
                        )
                          v-list-item-content
                            v-list-item-title.mb-1.text-wrap {{ slotItem.foodItemTitle }}
                            v-list-item-subtitle
                              v-chip.mr-1(label color="primary")
                                strong {{ slotItem.menuGroupSlotCode }}
                              v-chip.mr-1(
                                v-for="(tag, tagIdx) in slotItem.tags"
                                :key="tagIdx"
                                label
                              )
                                v-icon.left(x-small) {{ tag.iconClass }}

                          v-list-item-action
                            v-tooltip(bottom)
                              template(v-slot:activator="{ on, attrs }")
                                v-btn.text-h6(
                                  :color="getStatusColor(dateItem)"
                                  fab small
                                  v-bind="attrs"
                                  v-on="on"
                                ) {{ slotItem.amount }}
                                  span.font-style x
                              span {{ getTitle(dateItem) }}

                    v-divider.my-2

                    v-row.ma-0(v-if="showRatingLastOrder && isOfferDelivered(dateItem)")
                      v-col.text-center.pa-0(cols="12")
                        v-subheader.subtitle-2.pa-0
                          v-col.pa-0(cols="12") {{ $t('ratingDialog.rating') }} :
                            v-btn.ml-2(icon @click="onShowRatingDialogClick(dateItem)" :style="{ opacity: getRatingValue(dateItem) === 1 ? '3' : '0.3' }")
                              v-icon(color="error" :style="{ fontSize: getRatingValue(dateItem) === 1 ? '30px' : '15px' }") fas fa-grimace
                            v-btn.ml-2(icon @click="onShowRatingDialogClick(dateItem)" :style="{ opacity: getRatingValue(dateItem) === 2 ? '3' : '0.3' }")
                              v-icon(color="orange" :style="{ fontSize: getRatingValue(dateItem) === 2 ? '30px' : '15px' }") fas fa-frown-open
                            v-btn.ml-2(icon @click="onShowRatingDialogClick(dateItem)" :style="{ opacity: getRatingValue(dateItem) === 3 ? '3' : '0.3' }")
                              v-icon(color="primary" :style="{ fontSize: getRatingValue(dateItem) === 3 ? '30px' : '15px' }") fas fa-smile
                            v-btn.ml-2(icon @click="onShowRatingDialogClick(dateItem)" :style="{ opacity: getRatingValue(dateItem) === 4 ? '3' : '0.3' }")
                              v-icon(color="success" :style="{ fontSize: getRatingValue(dateItem) === 4 ? '30px' : '15px' }") fas fa-grin-hearts
          v-tab-item.pt-3
            v-card.elevation-0
              v-card-text(v-if="!fetchInProgress && itemData.length === 0")
                v-row.ma-0.justify-space-around()
                  v-col.text-center.font-weight-bold.title(justify="center" cols="12") Žiadne objednávky
              v-card-text.pa-0.overflow-y-auto(style="height:58vh" v-else)
                v-list( v-if="$vuetify.breakpoint.mdAndUp")
                  template(v-for="(value, idx) in monthOrderReport")
                      v-divider(v-if="idx != 0")
                      v-list-item
                        v-row.ma-0
                          v-col.pt-4(cols="3").title.justify-start
                            span {{value.code}}
                          v-col.text-center(cols="7")
                            v-tooltip(bottom )
                              template(v-slot:activator="{ on, attrs }")
                                v-btn.text-h6( fab small color="primary" v-bind="attrs" v-on="on" ) {{value.summary.active}}
                                  span.font-style x
                              span {{ $t('myOrderPage.active') }}
                            v-tooltip(bottom )
                              template(v-slot:activator="{ on, attrs }")
                                v-btn.ml-3.text-h6( fab small color="success" v-bind="attrs" v-on="on" ) {{value.summary.delivered}}
                                  span.font-style x
                              span {{ $t('myOrderPage.delivered') }}
                            v-tooltip(bottom )
                              template(v-slot:activator="{ on, attrs }")
                                v-btn.ml-3.text-h6( fab small color="error" v-bind="attrs" v-on="on" ) {{value.summary.canceled}}
                                  span.font-style x
                              span {{ $t('myOrderPage.canceled') }}
                          v-col.text-end.ma-0(cols="2")
                            v-tooltip(bottom )
                              template(v-slot:activator="{ on, attrs }")
                                v-btn.text-h6(fab small color="blue-grey lighten-5" v-bind="attrs" v-on="on" ) {{value.summary.totalAmount}}
                                  span.font-style x
                              span {{ $t('myOrderPage.totalLabel') }}
                v-list( v-else)
                  template(v-for="(value, idx) in monthOrderReport" )
                    v-divider(v-if="idx != 0")
                    v-list-item
                      v-row.ma-0
                        v-col.text-start.pt-4(cols="3")
                          span.text-h6 {{value.code}}
                        v-col.text-center(cols="7")
                          v-tooltip(bottom )
                            template(v-slot:activator="{ on, attrs }")
                              v-btn.text-h6( fab small color="primary" v-bind="attrs" v-on="on" ) {{value.summary.active}}
                                span.font-style.text x
                            span {{ $t('myOrderPage.active') }}
                          v-tooltip(bottom )
                            template(v-slot:activator="{ on, attrs }")
                              v-btn.ml-3.text-h6( fab small color="success" v-bind="attrs" v-on="on" ) {{value.summary.delivered}}
                                span.font-style x
                            span {{ $t('myOrderPage.delivered') }}

                          v-tooltip(bottom )
                            template(v-slot:activator="{ on, attrs }")
                              v-btn.ml-3.text-h6( fab small color="error" v-bind="attrs" v-on="on" ) {{value.summary.canceled}}
                                span.font-style x
                            span {{ $t('myOrderPage.canceled') }}

                        v-col.text-end(cols="2")
                          v-tooltip(bottom )
                            template(v-slot:activator="{ on, attrs }")
                              v-btn.text-h6(fab small color="blue-grey lighten-5" v-bind="attrs" v-on="on" ) {{value.summary.totalAmount}}
                                span.font-style x
                            span {{ $t('myOrderPage.totalLabel') }}


        v-skeleton-loader.pt-6(v-else type="paragraph@7 " width="100%")
</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import moment from 'moment/moment'
import axios from '@/plugins/axios'
import MenuReservationItem from '@/model/MenuReservationItem'
import { CurrentUser } from '@/model/CurrentUser'
import { USER_LOGGED_IN } from '@/store/getter-types'
import _ from 'lodash'
import SummaryMonthOrder from "@/model/SummaryMonthOrder";
import i18n from "@/plugins/i18n";
import RatingDialog from "@/components/dashboard/RatingDialog.vue";
import {usePiniaStore} from "@/store/piniaStore";
import {CustomerResponse} from "@/types/service-response";
import {RatingModel} from "@/model/RatingModel";


interface MonthSummaryReport {
    code: string,
    summary: {
      active: number,
      canceled: number,
      delivered: number,
      totalAmount: number,
    }
}

@Component({
  components: {
    RatingDialog
  }
})
export default class MyOrderPage extends Vue {

  $refs!: {
    dateMenu: Vue & {
      save(date: string): void,
    },
  }

  private fetchInProgress: boolean = false
  private monthOrderList: MenuReservationItem[] = []
  private selectedMonth: string | null = ''
  private dateMenu: boolean = false
  private itemData: SummaryMonthOrder[] = [];
  private monthOrderReport: MonthSummaryReport[] = []
  private tab: number = 0
  private snackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private ratingValue: number | null = null
  private showDetailLastOrderClick: boolean = false
  private lastReservationDetailData: any[] = []
  private lastReservationNumber: number[] | null = []
  private piniaStore: any = usePiniaStore()
  private date: string = ''
  private boarderId: any | null = null
  private ratingDataList: RatingModel[] = []
  private ratingValueList: any[] = []
  private selectedOffer: any | null = null
  private selectedOfferRating: RatingModel | null = null
  private showRatingLastOrder: boolean = false
  private ratingDeliveryTimeData: number | null= null

  isOfferDelivered (item:any): boolean {
    if(item.status.name === 'delivered') {
      return true
    } else {
      return false
    }

  }


  get getIcon () {
    if (this.ratingValue === 1) {
      return 'fas fa-grimace'
    } else if (this.ratingValue === 2) {
      return 'fas fa-frown-open'
    } else if (this.ratingValue === 3) {
      return 'fas fa-smile'
    } else if (this.ratingValue === 4) {
      return 'fas fa-grin-hearts'
    }
  }

  getRatingValue(item: any):number| null {
    let foundItem: any | undefined = this.ratingDataList.find((i:RatingModel) => i.offerReservations.includes(`/api/food-ordering/offer-reservation/${item.id}`))
    return foundItem ? foundItem.value : null
  }

  async onShowRatingDialogClick (item: any): Promise<void> {
    try {
      // Fetch full reservation detail (item endpoint includes offerReservationDelivery
      // and reservedOffers, which the collection list payload does not) so the rating
      // dialog can correctly evaluate the delivery time window and submit.
      const detail = await this.piniaStore.fetchLastOrder(item.id)
      this.lastReservationDetailData = [[detail]]
      this.selectedOfferRating = this.ratingDataList.find((r: RatingModel) =>
        r.offerReservations.includes(`/api/food-ordering/offer-reservation/${item.id}`)) || null
      this.selectedOffer = null
      this.showDetailLastOrderClick = true
    } catch (e) {
      this.snackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    }
  }

  setOpacity (value:any):any {
    if(value) {
      this.ratingValue = value !== null ? value : null;
    }
    return this.ratingValue

  }

  get getReservationData():any {
    let data:any[] = []
    this.lastReservationDetailData!.forEach((item:any) => {
      item.forEach((i:any) => {
        data.push(i)
      })

    })
    return data
  }

  get currentUser(): any {
    return this.$store.getters[USER_LOGGED_IN]
  }

  get getCardClass (): string {
    let width: string = ''
    if(this.$vuetify.breakpoint.mdAndUp){
      width = '600px'
    } else {
      width = ''
    }
    return width
  }

  get userLoggedIn(): CurrentUser{
    return this.$store.getters[USER_LOGGED_IN]
  }

  get getMonth(): string {
     return this.selectedMonth ? moment(this.selectedMonth).locale('sk').format('MMMM YYYY').toLocaleUpperCase() : moment().locale('sk').format('MMMM YYYY').toLocaleUpperCase()
  }

  getDate(item: string): string {
    return moment(item).locale('sk').format('D.M. dddd')
  }

  getStatusColor(item: SummaryMonthOrder): string {
    const statusName: string = item.status.name;
    if (statusName === 'canceled') {
      return 'error';
    } else if (statusName === 'delivered') {
      return 'success';
    }
    return 'primary'
  }

  getTitle(item: SummaryMonthOrder): string {
    const statusName: string = item.status.name;
    if (statusName === 'canceled') {
      return  i18n.t('myOrderPage.canceled').toString()
    } else if (statusName === 'delivered') {
      return  i18n.t('myOrderPage.delivered').toString()
    } else {
      return i18n.t('myOrderPage.active').toString()
    }

  }

  closeRatingDialog(): void{
    this.showDetailLastOrderClick = false
    this.fetchOfferRatigList()
  }

  refreshData (): void {
    this.showDetailLastOrderClick = false
    this.fetchOfferRatigList()
  }

  onMonthChange (item: string) {
    this.selectedMonth = item
    this.fetchData()
  }

  onNextButtonClick (): void {
    this.selectedMonth = moment(this.selectedMonth, 'YYYY-MM').add(1,'month').format('YYYY-MM')
    this.fetchData()
  }

  onPrevButtonClick (): void {
    this.selectedMonth = moment(this.selectedMonth, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM')
    this.fetchData()
  }

  async fetchData(): Promise<void> {
    const start_date = moment(this.selectedMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD')
    const end_date = moment(this.selectedMonth, 'YYYY-MM').startOf('month').format('YYYY-MM-DD')
    const boarder = this.userLoggedIn.boarderList[0].id
    try {
       this.fetchInProgress = true
       const response = await axios.get('/api/food-ordering/offer-reservation?date[before]=' + start_date + '&date[after]=' + end_date + '&boarder.id=' + boarder)
       this.monthOrderList = response.data
      this.lastReservationNumber = []
       this.monthOrderList.forEach((item:any) => {
          this.lastReservationNumber!.push(item.id)
          this.boarderId = item.boarder.id
        })
        if(this.lastReservationNumber !== null && this.monthOrderList && this.monthOrderList.length > 0) {
          await this.fetchOfferRatigList()
        }
       this.itemData = this.processItemData(this.monthOrderList)

       this.monthOrderReport = this.processSummaryData(this.itemData)
    } catch (e) {
      this.snackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
      this.fetchInProgress = false
    }
  }

  processItemData(orders: MenuReservationItem[]): any[] {
    const result: any[] = [];

    // Group orders by date
    const ordersByDate = _.groupBy(orders, 'date');

    // Process each date group
    Object.entries(ordersByDate).forEach(([date, ordersForDate]) => {
      const topMenuGroupMap = new Map<string, any>();

      // Process each order for this date
      ordersForDate.forEach(order => {
        const topMenuGroupTitle = order.topMenuGroup?.title || '';
        const topMenuGroupOrder = order.topMenuGroup?.order || 0;

        // Get or create topMenuGroup entry
        if (!topMenuGroupMap.has(topMenuGroupTitle)) {
          topMenuGroupMap.set(topMenuGroupTitle, {
            topMenuGroupTitle: topMenuGroupTitle,
            topMenuGroupOrder: topMenuGroupOrder,
            subMenuGroups: new Map<string, any>() // Store subMenuGroups for hierarchy
          });
        }

        const topMenuGroup = topMenuGroupMap.get(topMenuGroupTitle);

        // Process subMenuGroups
        order.topMenuGroup?.subMenuGroups?.forEach((subMenuGroup: any) => {
          const subMenuGroupTitle = subMenuGroup.title || '';
          const subMenuGroupOrder = subMenuGroup.order || 0;

          // Get or create subMenuGroup entry
          if (!topMenuGroup.subMenuGroups.has(subMenuGroupTitle)) {
            topMenuGroup.subMenuGroups.set(subMenuGroupTitle, {
              subMenuGroupTitle: subMenuGroupTitle,
              subMenuGroupOrder: subMenuGroupOrder,
              slots: [] // Stores slot data
            });
          }

          const subMenuGroupEntry = topMenuGroup.subMenuGroups.get(subMenuGroupTitle);

          // Process menuGroupSlots
          subMenuGroup.menuGroupSlots?.forEach((slot: any) => {
            // Find matching offers for this slot
            const matchingOffers = order.reservedOffers.filter(
              offer => offer.dailyMenuOffer.menuGroupSlot.id === slot.id
            );

            if (matchingOffers.length > 0) {
              const totalAmount = _.sumBy(matchingOffers, 'amount');
              const foodItemTitle = matchingOffers[0]?.dailyMenuOffer?.referenceFoodItem?.title || '';
              const slotTags = slot.tags.map((tag: any) => ({
                title: tag.title,
                iconClass: tag.iconClass
              }));

              subMenuGroupEntry.slots.push({
                menuGroupSlotId: slot.id,
                menuGroupSlotCode: slot.code,
                order: slot.order || 0,
                foodItemTitle: foodItemTitle,
                tags: slotTags,
                amount: totalAmount
              });
            }
          });
        });
      });

      // Build dataPerTopMenuGroup array
      const dataPerTopMenuGroup: any[] = [];

      topMenuGroupMap.forEach((topMenuGroup) => {
        const subMenuGroups = Array.from(topMenuGroup.subMenuGroups.values());

        // Sort subMenuGroups by order
        const sortedSubMenuGroups = _.orderBy(subMenuGroups, ['subMenuGroupOrder'], ['asc']);

        // Sort slots within each subMenuGroup by order
        sortedSubMenuGroups.forEach((subMenuGroup: any) => {
          subMenuGroup.slots = _.orderBy(subMenuGroup.slots, ['order'], ['asc']);
        });

        dataPerTopMenuGroup.push({
          topMenuGroupTitle: topMenuGroup.topMenuGroupTitle,
          order: topMenuGroup.topMenuGroupOrder,
          subMenuGroupData: sortedSubMenuGroups // Use subMenuGroupData for hierarchy
        });
      });

      // Sort topMenuGroups by order
      const sortedTopMenuGroups = _.orderBy(dataPerTopMenuGroup, ['order'], ['asc']);

      result.push({
        date: date,
        dataPerTopMenuGroup: sortedTopMenuGroups,
        status: ordersForDate[0].status,
        id: ordersForDate[0].id,
        boarderNote: ordersForDate[0].boarderNote
      });
    });

    return result;
  }

  processSummaryData(itemData: any[]): MonthSummaryReport[] {
    return _(itemData)
      .flatMap(order =>
        order.dataPerTopMenuGroup.flatMap((topMenuGroup: any) =>
          topMenuGroup.subMenuGroupData.flatMap((subMenuGroup: any) =>
            subMenuGroup.slots.map((slotItem: any) => ({
              topGroupOrder: topMenuGroup.order,
              subGroupOrder: subMenuGroup.subMenuGroupOrder,
              slotOrder: slotItem.order,
              slotId: slotItem.menuGroupSlotId,
              slotCode: slotItem.menuGroupSlotCode,
              amount: slotItem.amount,
              tags: slotItem.tags,
              status: order.status.name
            }))
          )
        )
      )
      .groupBy('slotId')
      .map((slotItems, slotId) => {
        const totalAmount = _.sumBy(slotItems, 'amount');
        const slotCode = slotItems[0].slotCode;
        const tags = _.uniqBy(_.flatMap(slotItems, 'tags'), 'title');

        const topGroupOrder = slotItems[0].topGroupOrder;
        const subGroupOrder = slotItems[0].subGroupOrder;
        const slotOrder = slotItems[0].slotOrder;

        const summary = {
          active: _.sumBy(slotItems.filter(item => item.status === 'active'), 'amount'),
          canceled: _.sumBy(slotItems.filter(item => item.status === 'canceled'), 'amount'),
          delivered: _.sumBy(slotItems.filter(item => item.status === 'delivered'), 'amount'),
          totalAmount: totalAmount,
          tags: tags
        };

        return {
          code: slotCode,
          slotId: parseInt(slotId, 10),
          topGroupOrder,
          subGroupOrder,
          slotOrder,
          summary
        };
      })
      // Sort: topGroup first, then subGroup, then slot
      .sortBy(['topGroupOrder', 'subGroupOrder', 'slotOrder'])
      .value();
  }

  async fetchOfferRatigList(): Promise<void> {
    let reservationId: any[] = []
    if(this.lastReservationNumber !== null) {
      this.lastReservationNumber.forEach((item:any) => {
        reservationId.push(item)
      })
    }
    const payload: any =  {
      boarderId: this.boarderId,
      id: reservationId
    }
    try {
      const response:any  = await this.piniaStore.fetchOfferRating(payload)
      this.ratingDataList = response
      this.ratingDataList.forEach((item:RatingModel) => {
        this.ratingValue = item.value
      })
      this.monthOrderList.forEach((item:any) => {
        this.lastReservationNumber!.push(item.id)
      })
    } catch (e) {
    }
  }

  async fetchCustomer(): Promise<void> {
    let payload: any = this.currentUser.boarderList[0].customer.id
    try {
      const response = await this.piniaStore.fetchCustomerQrConfiguration(payload)
      this.showRatingLastOrder = response.configuration.allow_rating_last_order || false
      this.ratingDeliveryTimeData = response.configuration.last_order_rating_delivery_time_delta
    } catch (e) {
    } finally {
    }
  }

  mounted () {
    this.fetchCustomer()
    this.selectedMonth = moment().format('YYYY-MM')
    this.fetchData()
  }
}
</script>

<style lang="stylus" scoped>
.font-style
  font-size 12px
  padding-top: 5px;
.icon-size {
  font-size: 30px;
}
</style>
